import useWordings from '@v4/hooks/useWordings'
import useStyles from './SubmitButton.styled'

export const useSubmitButton = ({ onClick, loading, className, children, editable, onChange }) => {
	const { getWording } = useWordings()
	const classes = useStyles()

	return [
		{ classes, loading, className, editable, children: children ?? getWording('nextButton') },
		{ handleClick: onClick, handleChange: onChange },
	]
}
